<template>
  <div class="container-fluid">
    <br />
    <b-row v-if="user">
      <b-col class="col-sm-12 col-xl-6">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-user"></i> Detalhes do Usuário
          </div>
          <div class="card-body" v-if="user">
            <ul class="list-group">
              <li class="list-group-item" v-if="whitelabel">Whitelabel: <b>{{whitelabel.name}}</b></li>
              <li class="list-group-item">Nome: {{user.name}}</li>
              <li class="list-group-item">
                Email: {{user.email}} <b-badge v-if="!user.emailConfirmationTime" variant="danger">Não confirmado</b-badge>
                <br/>
                <b-button v-if="!user.emailConfirmationTime" variant="success" @click="confirmEmail">Confirmar</b-button>
              </li>
              <li class="list-group-item" v-if="user && user.subscription">Edições Iniciadas: {{user.subscription.startedEditionCount}}</li>
              <li class="list-group-item" v-if="user && user.subscription">Downloads: {{user.subscription.editionCount}}</li>
              <li class="list-group-item">Whatsapp: 
                <b-button v-if="user && user.whatsapp" @click="openWhatsapp(user.whatsapp, user._id)" variant="primary">
                  Whatsapp
                </b-button></li>
              <li class="list-group-item">Instagram:  <a
                  target="_blank"
                  v-bind:href="'https://instagram.com/' + user.instagram"
                >{{user.instagram}}</a></li>
              <li class="list-group-item">Cupom: {{!user.coupon ? "Nenhum" : user.coupon.name}}</li>
              <li v-if="user && user.createdAt && user.createdAt._now"
                class="list-group-item"
              >Data de Criação: {{user.createdAt._now | moment("DD/MM/YYYY HH:mm")}}</li>
              <li class="list-group-item" v-if="user &&  user.subscription && user.subscription.status">
                Tipo de Assinatura:
                <b-badge
                  :variant="getSubscriptionBadge(user.subscription.status)"
                >{{(parseInt(user.subscription.status) === 0 || parseInt(user.subscription.status) === 2 )? "Free" : (parseInt(user.subscription.status) === 1) ? "Premium Ilimitado" : "Premium Limitado "}}</b-badge>
              </li>
              <li
                class="list-group-item" v-if="user && user.subscription && user.subscription.due"
              >Data de expiração: {{user.subscription.due | moment("DD/MM/YYYY HH:mm")}}</li>
              <li
                class="list-group-item" v-if="user && user.subscription && user.subscription.due"
              >Uso do e-book: <span v-if="user && user.limitedFreeUseOfEbook">{{user.limitedFreeUseOfEbook | moment("DD/MM/YYYY HH:mm")}}</span> <span v-else>Não tem acesso</span>
                <b-button v-if="user && !user.limitedFreeUseOfEbook" @click="allowEbook()" variant="primary">
                  Liberar e-book até o fim da assinatura
                </b-button>
              </li>
              <li
                class="list-group-item" v-if="user && user.subscription"
              >Uso do desafio: <span v-if="user && user.challengeAccess">{{user.challengeAccess | moment("DD/MM/YYYY HH:mm")}}</span> <span v-else>Não tem acesso</span>
                <b-button v-if="user && !user.challengeAccess" @click="allowChallengeAccess()" variant="warning">
                  Liberar desafio até o fim da assinatura
                </b-button>
              </li>
              <li
                class="list-group-item" v-if="user && user.subscription"
              >Créditos: {{user.subscription.credits ? user.subscription.credits : 0}}</li>
              <li class="list-group-item" v-if="user && user.subscription && user.subscription.editionCount">Total de Edições: {{user.subscription.editionCount}}</li>
              <li
                class="list-group-item"
              >Confirmação de Email: {{user.emailConfirmationTime | moment("DD/MM/YYYY HH:mm")}}</li>
              <li
                class="list-group-item"
              >Redefinição de Senha: <b-button v-if="user && !user.passwordResetToken" @click="requestPasswordReset()" variant="primary">
                  Criar link de redefinição
                </b-button>{{user.passwordResetToken ? 'https://sleeker.pt/pages/create-password/'+ user.passwordResetToken : ''}}</li>
            </ul>
          </div>
        </div>
      </b-col>
      <b-col class="col-sm-12 col-xl-6">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-edit"></i> Alterar Usuário
          </div>
          <div class="card-body">
            <form class="form-horizontal" action method="post" enctype="multipart/form-data">
              <div class="form-group row">
                <label class="col-md-3 col-form-label" for="text-input">Nome</label>
                <div class="col-md-9">
                  <input
                    class="form-control"
                    id="text-input"
                    type="text"
                    name="text-input"
                    v-model="name"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 col-form-label" for="email-input">Email</label>
                <div class="col-md-9">
                  <input
                    class="form-control"
                    id="email-input"
                    type="email"
                    name="email-input"
                    v-model="email"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 col-form-label" for="password-input">Senha</label>
                <div class="col-md-9">
                  <input
                    class="form-control"
                    id="password-input"
                    type="password"
                    name="password-input"
                    v-model="password"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 col-form-label" for="textarea-input">Observações</label>
                <div class="col-md-9">
                  <textarea
                    class="form-control"
                    id="textarea-input"
                    name="textarea-input"
                    rows="1000"
                    v-model="user.details"
                    style="overflow-y: auto; max-height: 140px !important;"
                  ></textarea>
                </div>
              </div>
            </form>
          </div>
          <div class="card-footer text-center">
            <button class="btn btn-sm btn-primary" v-on:click="updateUser()" type="submit">
              <i class="fa fa-save"></i> Alterar dados
            </button>
          </div>

          <br />
          <br />
          <div>
            <div class="card-body">
              <div class="form-group row" v-if="whitelabel">
                <label class="col-md-3 col-form-label" for="date-input">Dias disponíveis:</label>
                <div class="col-md-9">
                  <input
                    class="form-control"
                    id="days-input"
                    type="number"
                    name="days-input"
                    disabled
                    v-model="whitelabel.days"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 col-form-label" for="date-input">Inserir Dias:</label>
                <div class="col-md-9">
                  <input
                    class="form-control"
                    id="days-input"
                    type="number"
                    name="days-input"
                    v-model="daysToAdd"
                  />
                </div>
              </div>
              <div v-if="isAdmin" class="form-group row">
                <label class="col-md-3 col-form-label" for="date-input">Inserir Créditos:</label>
                <div class="col-md-9">
                  <input
                    class="form-control"
                    id="days-input"
                    type="number"
                    name="days-input"
                    v-model="creditsToAdd"
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12">
                  <b-form-select id="basicSelectLg"
                    v-model="subscriptionType"
                    size="lg"
                    :plain="true"
                    :options="[{value: 0, text: 'Escolha um tipo de assinatura'},{value: 1, text: 'Ilimitada'}, {value: 2, text: 'Free'}, {value: 3, text: 'Limitada'}]"
                    value="Please select">
                  </b-form-select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12">
                  <b-form-select id="basicSelectLg"
                    v-model="planType"
                    size="lg"
                    :plain="true"
                    :options="[{value: 'PREMIUM', text: 'PREMIUM'},{value: 'VIP', text: 'VIP'}, {value: 'FREEPASS', text: 'FREEPASS'}]"
                    value="Please select">
                  </b-form-select>
                </div>
              </div>
            </div>
            <div class="card-footer text-center" >
              <spinner v-if="loadingData == true"></spinner>
              <button v-if="!loadingData" class="btn btn-sm btn-primary" v-on:click="addUserDays()" type="submit">
                <i class="fa fa-save"></i> Inserir
              </button>
            </div>
          </div>
        </div>
      </b-col>
      <b-col sm="12">
        <b-card>
          <b-row>
            <b-col sm="3">
              <p>Contatos:</p>
            </b-col>
            <b-col sm="2" class="text-right">
              <b-button variant="success" @click="registerSale">Registrar Venda</b-button>
            </b-col>
            <b-col sm="5" class="text-right">
              <input
                class="form-control"
                type="text"
                placeholder="Descreva o contato..."
                v-model="contactDescription"
              />
            </b-col>
            <b-col sm="2" class="text-right">
              <b-button variant="primary" @click="registerContact">Registrar Contato</b-button>
            </b-col>
          </b-row>
          <ul class="list-group" v-if="contacts">
            <div v-for="(contact, index) in contacts" :key="index">
              <li class="list-group-item" v-if="!contact.automatic"><b-badge variant="success" v-if="contact.sale">Venda</b-badge><b-badge variant="primary" v-if="!contact.sale">Contato</b-badge>  {{contact.insertionDate | moment("DD/MM/YYYY HH:mm")}}: <b>{{adminsMap[contact.admin] ? adminsMap[contact.admin] : contact.admin}}</b> {{contact.description ? (" - " + contact.description) : ""}}</li>
            </div>
          </ul>
        </b-card>
      </b-col>
    </b-row>
    <br />
    <b-row>
      <b-col class="col-lg-12">
        <payment-history
          :userId="user._id"
          striped
          :admin="true"
          :adminType="user.adminType"
          caption="<i class='fa fa-align-justify'></i> Histórico de Pagamentos"
          v-if="user.subscription"
        ></payment-history>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-card>
          <b-row>
            <b-col sm="3">
              <p>Aquisição:</p>
            </b-col>
          </b-row>
          <ul class="list-group" v-if="user.trackingData">
            <div v-for="(trackingData, index) in user.trackingData" :key="index">
              <li class="list-group-item"> {{trackingData | moment("DD/MM/YYYY HH:mm")}}: <b>{{index}}</b></li>
            </div>
          </ul>
        </b-card>
      </b-col>
      <b-col sm="12">
        <b-card>
          <b-row>
            <b-col sm="3">
              <p>Email:</p>
            </b-col>
          </b-row>
          <ul class="list-group" v-if="user.emailFlow">
            <div v-for="(emailFlow, index) in user.emailFlow" :key="index">
              <li class="list-group-item"> {{emailFlow | moment("DD/MM/YYYY HH:mm")}}: <b>{{index}}</b></li>
            </div>
          </ul>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import service from "../service";
import Spinner from "./Spinner";
import PaymentHistory from "./PaymentHistory";

export default {
  name: "ResellerManage",
  data: () => {
    return {
      userId: "",
      user: {},
      name: undefined,
      email: undefined,
      password: undefined,
      daysToAdd: 0,
      creditsToAdd: 0,
      loadingData: false,
      whitelabel: undefined,
      type: undefined,
      contacts: [],
      contactDescription: "",
      subscriptionType: 0,
      planType: "PREMIUM"
    };
  },
  methods: {
    requestPasswordReset: function() {
      this.success = false;
      this.errorMessage = undefined;

      service.requestPasswordReset(this.user.email).then(() => {
        this.getUser();
      }).catch(() => {
        this.errorMessage = "Ocorreu um erro. Por favor, procure o suporte.";
      });
      
    },
    allowEbook: function() {
      this.success = false;
      this.errorMessage = undefined;

      service.allowEbook(this.user._id).then(() => {
        this.getUser();
      }).catch(() => {
        this.errorMessage = "Ocorreu um erro. Por favor, procure o suporte.";
      });
    },
    allowChallengeAccess: function() {
      this.success = false;
      this.errorMessage = undefined;

      service.allowChallengeAccess(this.user._id).then(() => {
        this.getUser();
      }).catch(() => {
        this.errorMessage = "Ocorreu um erro. Por favor, procure o suporte.";
      });
    },
    getSubscriptionBadge(paymentStatus) {
      return (paymentStatus === 0 || paymentStatus === 2) ? "primary" : "success";
    },
    getUser: function() {
      this.loadingData = true;
      service.getUser(this.userId).then(response => {
        this.loadingData = false;
        this.user = response.user;
        this.name = this.user.name;
        this.email = this.user.email;
        this.subscriptionType = this.user.subscription.status;
        (this.user.subscription.planType) ? this.planType = this.user.subscription.planType : this.planType = "PREMIUM";
      });
    },
    updateUser: function() {
      let shouldUpdate = true;
      if (shouldUpdate) {
        service
          .updateUser({
            email: this.email,
            name: this.name,
            details: this.user.details,
            whatsapp: this.whatsapp,
            oldPassword: this.user.password,
            password: this.password,
            sudoUpdate: true
          }, this.user._id)
          .then(user => {
            this.getUser();
            this.daysToAdd = 0;
            this.creditsToAdd = 0;
            this.password = null;
            alert("Dados alterados com sucesso");
          })
          .catch(error => {
            if (error && error.message) {
              alert(error.message);
            } else {
              alert("Ocorreu um erro inesperado");
            }
          });
      }
    },
    getWhitelabel: function() {
      service.getWhitelabel().then((response) => {
        if (response && response.whitelabel) {
          this.whitelabel = response.whitelabel;
        }
      });
    },
    confirmEmail: function() {
      this.loadingData = true;
      service
        .confirmUserEmail(this.user._id)
        .then(response => {
          this.loadingData = false;
          this.daysToAdd = 0;
          this.creditsToAdd = 0;
          this.getUser();
          this.getWhitelabel();
        })
        .catch(error => {
          this.loadingData = false;
          if (error && error.message) {
            alert(error.message);
          } else {
            alert("Ocorreu um erro inesperado");
          }
        });
    },
    addUserDays: function() {
      if (this.subscriptionType == 0) {
        alert("Escolha um tipo de assinatura");
      } else {
        this.loadingData = true;
        service
          .addUserDays(this.user._id, this.daysToAdd, this.creditsToAdd, this.subscriptionType, this.planType)
          .then(response => {
            this.loadingData = false;
            this.daysToAdd = 0;
            this.getUser();
            this.getWhitelabel();
          })
          .catch(error => {
            this.loadingData = false;
            if (error && error.message) {
              alert(error.message);
            } else {
              alert("Ocorreu um erro inesperado");
            }
          });
      }
    },
    registerContact: function () {
      service.registerContact(this.userId, this.contactDescription).then((response) => {
        if (response && response.contacts) {
          this.contacts = response.contacts;
          this.contactDescription = "";
        }
      });
    },
    registerSale: function () {
      console.log(123);
      service.registerSale(this.userId, this.contactDescription).then((response) => {
        if (response && response.contacts) {
          this.contacts = response.contacts;
          this.contactDescription = "";
        }
      });
    },
    openWhatsapp(whatsapp, userId) {
      service.whatsappLinkClick(userId).then(() => {
        let url = 'https://api.whatsapp.com/send?l=pt_BR&phone=55' + whatsapp;
        window.open(url, "_blank");
      });
    }
  },
  components: { Spinner, PaymentHistory },
  created() {
    console.log("criado");
    this.userId = this.$route.params.id;
    this.type = this.$route.params.type;
    this.getUser();
    this.getWhitelabel();

    service.getAdmins().then(
      response => {
        this.admins = response.admins;
        this.adminsMap = {};
        for (let key in this.admins) {
          let admin = this.admins[key];
          this.adminsMap[admin.id] = admin.name;
        }
      },
      () => {
        this.showError = true;
      }
    );

    service.getContacts(this.userId).then((response) => {
      if (response && response.contacts) {
        
        this.contacts = response.contacts;
        console.log(this.contacts);
      }
    });
  }, 
  computed: {
    isAdmin: function() {
      return localStorage.admin;
    },
  }
};
</script>


